var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.852 8.606a.3.3 0 00-.45.26v6.268a.3.3 0 00.45.26l5.428-3.134a.3.3 0 000-.52l-5.428-3.134z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.512 5h-16a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h16a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zm-16-2a2.5 2.5 0 00-2.5 2.5v13a2.5 2.5 0 002.5 2.5h16a2.5 2.5 0 002.5-2.5v-13a2.5 2.5 0 00-2.5-2.5h-16z"
  }))));
}
export default __webpack_public_path__ + "media/small/video-6381cd49.svg";
export { SvgVideo as ReactComponent };